module.exports = __webpack_public_path__ + "static/img/15.e1e5eb7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/15.png
// module id = g50m
// module chunks = 0